import { BackofficeCustomerQueryModel } from "../../../../../../Models/API/BackofficeModel"
import { SortOptionField } from "../../../../../Common/Button/SortChooser"
import {
    dateTimeFilter,
    FilterFields
} from "../../../../../Common/FilterComposer/FilterComposer"
import {
    FilterExpression,
    UnaryFilterOperator
} from "../../../../../../Models/Client/FilterExpression"
import startOfDay from "date-fns/startOfDay"

const defaultDateOnAddFilter = startOfDay(new Date()).toISOString()
export const defaultBackofficeCustomerFilter: FilterExpression<BackofficeCustomerQueryModel> =
    {
        fieldName: "created",
        operator: UnaryFilterOperator.ge,
        value: defaultDateOnAddFilter
    }

export const backofficeCustomerSortFields: SortOptionField<BackofficeCustomerQueryModel>[] =
    [
        {
            field: "created",
            label: "Created",
            ascLabel: "first",
            descLabel: "recently"
        },
        {
            field: "email",
            label: "Email",
            ascLabel: "Ascending alphabetical order",
            descLabel: "Descending alphabetical order"
        }
    ]
export const backofficeCustomerFilterFields: FilterFields<BackofficeCustomerQueryModel> =
    {
        created: dateTimeFilter("Created", defaultDateOnAddFilter)
    }
